import React from "react";
import { autoFontColor } from "../../../../../utils/color";
import Tooltip from "../../../../../components/Tooltip/Tooltip";
import type { DepGraphActivity } from "../../../../../models";
import { kindFromTaskType, nodeStatus, rowFinish, rowStart } from "../../graphRows";

interface Props {
  activity: DepGraphActivity;
  partnerRole?: "feeder" | "fed";
  isSelected: boolean;
  anchorsTable: boolean;
  canSelect: boolean;
  canDelete: boolean;
  fmtDate: (iso: string | null) => string;
  onSelect: (id: string) => void;
  attachRowRef: (el: HTMLTableRowElement | null) => void;
}

const PartnerRow: React.FC<Props> = ({
  activity: act,
  partnerRole,
  isSelected,
  anchorsTable,
  canSelect,
  canDelete,
  fmtDate,
  onSelect,
  attachRowRef,
}) => {
  const pKind = kindFromTaskType(act.task_type);
  const pNonTask = pKind !== "task";
  const pStatus = nodeStatus(act);
  return (
    <tr
      ref={attachRowRef}
      className={
        "dep-table-row--partner" +
        (isSelected ? " dep-table-row--selected" : "")
      }
      onClick={() => onSelect(act.id)}
    >
      {canSelect && <td className="dep-table-col-select" />}
      <td className="dep-table-col-name">
        <div className="dep-table-name-row dep-table-name-row--partner">
          {pNonTask ? (
            <span className="dep-table-non-task-pill">
              <span className="dep-table-non-task-glyph" aria-hidden="true">
                {pKind === "milestone" ? "◆" : "○"}
              </span>
              {act.work_code && (
                <span className="dep-table-non-task-code">{act.work_code}</span>
              )}
            </span>
          ) : act.work_code ? (
            <Tooltip content={act.work_name ? `${act.work_code} · ${act.work_name}` : act.work_code}>
              <span
                className="dep-table-activity-pill"
                style={{
                  background: act.color || undefined,
                  color: act.color ? autoFontColor(act.color) : undefined,
                }}
              >
                <span className="dep-table-activity-pill-code">{act.work_code}</span>
                {act.work_name && (
                  <span className="dep-table-activity-pill-name">{act.work_name}</span>
                )}
              </span>
            </Tooltip>
          ) : null}
          <span className="dep-table-plain-name">{act.name}</span>
          {act.task_code && <span className="dep-table-plain-taskcode">{act.task_code}</span>}
          <span
            className="dep-table-origin-tag dep-table-origin-tag--insection"
            title={`Lives in this section — ${partnerRole === "feeder" ? "feeds the outside activity below" : "fed by the outside activity above"}`}
          >
            in section
          </span>
          {pStatus === "active" && (
            <span
              className="dep-table-status dep-table-status--active"
              title="In progress — started, not yet finished"
            >
              ●
            </span>
          )}
        </div>
      </td>
      <td className="dep-table-col-date">
        <span className="dep-table-date">{fmtDate(rowStart(act))}</span>
      </td>
      <td className="dep-table-col-date">
        <span className="dep-table-date">{fmtDate(rowFinish(act))}</span>
      </td>
      <td className="dep-table-col-dur">
        {pNonTask ? "—" : `${act.duration_days}d`}
      </td>
      <td className="dep-table-col-chips" />
      {!anchorsTable && <td className="dep-table-col-chips" />}
      {canDelete && <td className="dep-table-col-actions" />}
    </tr>
  );
};

export default PartnerRow;
